import { baseApi } from './baseApi';

/**
 * Pieces API endpoints
 * Handles CRUD operations for piece management
 */
export const piecesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /pieces/:pieceId - Fetch piece by ID
    getPieceById: builder.query({
      query: (pieceId) => `/pieces/${pieceId}`,
      providesTags: (result, error, pieceId) => [{ type: 'Piece', id: pieceId }],
    }),

    // POST /pieces - Create new piece
    createPiece: builder.mutation({
      query: (pieceData) => ({
        url: '/pieces',
        method: 'POST',
        body: pieceData,
      }),
      invalidatesTags: (result, error, pieceData) => [
        { type: 'Piece', id: 'LIST' },
        { type: 'Piece', id: `PRODUCT_${pieceData.product_id}` },
      ],
    }),

    // PATCH /pieces/:piece_id - Update piece
    updatePiece: builder.mutation({
      query: ({ piece_id, ...pieceData }) => ({
        url: `/pieces/${piece_id}`,
        method: 'PATCH',
        body: pieceData,
      }),
      invalidatesTags: (result, error, { piece_id, product_id }) => [
        { type: 'Piece', id: piece_id },
        { type: 'Piece', id: `PRODUCT_${product_id}` },
      ],
    }),

    // DELETE /pieces/:pieceId - Delete piece
    deletePiece: builder.mutation({
      query: ({ pieceId, productId }) => ({
        url: `/pieces/${pieceId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { pieceId, productId }) => [
        { type: 'Piece', id: pieceId },
        { type: 'Piece', id: `PRODUCT_${productId}` },
      ],
    }),

    // GET /pieces/:pieceId/materials - Get materials for piece
    getPieceMaterials: builder.query({
      query: (pieceId) => `/pieces/${pieceId}/materials`,
      providesTags: (result, error, pieceId) => [{ type: 'PieceMaterial', id: pieceId }],
    }),

    // POST /pieces/:pieceId/materials - Add material to piece
    addPieceMaterial: builder.mutation({
      query: ({ pieceId, materialId }) => ({
        url: `/pieces/${pieceId}/materials`,
        method: 'POST',
        body: { material_id: materialId },
      }),
      invalidatesTags: (result, error, { pieceId }) => [
        { type: 'PieceMaterial', id: pieceId },
        { type: 'Piece', id: pieceId },
      ],
    }),

    // PUT /pieces/:pieceId/materials - Update all materials for piece
    updatePieceMaterials: builder.mutation({
      query: ({ pieceId, materialIds }) => ({
        url: `/pieces/${pieceId}/materials`,
        method: 'PUT',
        body: { material_ids: materialIds },
      }),
      invalidatesTags: (result, error, { pieceId }) => [
        { type: 'PieceMaterial', id: pieceId },
        { type: 'Piece', id: pieceId },
      ],
    }),

    // DELETE /pieces/:pieceId/materials/:materialId - Remove material from piece
    removePieceMaterial: builder.mutation({
      query: ({ pieceId, materialId }) => ({
        url: `/pieces/${pieceId}/materials/${materialId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { pieceId }) => [
        { type: 'PieceMaterial', id: pieceId },
        { type: 'Piece', id: pieceId },
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetPieceByIdQuery,
  useCreatePieceMutation,
  useUpdatePieceMutation,
  useDeletePieceMutation,
  useGetPieceMaterialsQuery,
  useAddPieceMaterialMutation,
  useUpdatePieceMaterialsMutation,
  useRemovePieceMaterialMutation,
} = piecesApi;

